export const headerTypes = {
  outOfSync: 'outOfSync',
};

export const headerMessage = {
  [headerTypes.outOfSync]:
    'Ad server targeting is out-of-sync. Click ‘Save’ below and you’ll have \
    the option to update the ad server.',
};
